/**
 * Debug Constants
 * Centralized constants used across debug utilities
 */

/**
 * Delay in milliseconds to wait for pending renders/images to load before capturing screenshot.
 */
export const SCREENSHOT_RENDER_DELAY_MS = 100;

/**
 * Timeout in milliseconds for screenshot capture operation.
 * If html2canvas hangs, this prevents memory leaks by forcing resolution.
 */
export const SCREENSHOT_CAPTURE_TIMEOUT_MS = 30000; // 30 seconds

/**
 * LocalStorage key for enabling/disabling browser detection debug logging.
 * Enable by setting localStorage.setItem('browserDetection:debug', 'true')
 */
export const DEBUG_KEY = "browserDetection:debug";

/**
 * Maximum number of retries for creating a debug session when network failures occur.
 */
export const MAX_RETRIES = 2;

/**
 * Initial delay in milliseconds before the first retry attempt.
 * Subsequent retries use exponential backoff (delay * 2^attempt).
 */
export const INITIAL_RETRY_DELAY_MS = 1000; // 1 second

/**
 * Timeout in milliseconds for waiting for extension debug dump response.
 * If the extension doesn't respond within this time, continue without extension events.
 */
export const EXTENSION_DEBUG_DUMP_TIMEOUT_MS = 5000; // Keep above extension's collection window to avoid racing timeouts
